const VERB_BGCOLOR = {
  GET: 'primary.main',
  POST: 'success.main',
  PUT: 'warning.main',
  PATCH: 'text.secondary',
  DELETE: 'error.main',
};

export const integrationOptionStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  minWidth: 0,
  width: '100%',
};

export const integrationOptionLogoStyles = {
  width: 28,
  height: 28,
  borderRadius: '6px',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: 'primary.main',
  color: 'common.white',
  fontWeight: 700,
  fontSize: '11px',
};

export const integrationOptionTextStyles = {
  minWidth: 0,
  flex: 1,
  lineHeight: 1.35,
};

export const endpointBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  mt: '6px',
  bgcolor: 'text.primary',
  color: 'background.paper',
  borderRadius: '6px',
  px: '8px',
  py: '4px',
  fontFamily: 'monospace',
  fontSize: '11px',
};

export const getVerbBadgeStyles = verb => ({
  borderRadius: '4px',
  px: '5px',
  py: '1px',
  fontWeight: 700,
  fontSize: '10px',
  lineHeight: '14px',
  bgcolor: VERB_BGCOLOR[verb] ?? 'text.secondary',
  color: 'common.white',
});
